import React, { memo } from 'react';
import clsx from 'clsx';
import './tag-with-suggestions.scss';
import PropTypes from 'prop-types';
import Input from '../../../input';
import ContextMenu from '../../../context-menu/context-menu';
import BadgeWrapper from '../badge-wrapper/badge-wrapper';
import useTranslation from '../../../../../utils/translation-utils';
import { DEFAULT_LABEL_ACCESSOR } from '../../constants';

const TagWithSuggestions = React.forwardRef(({
  tags, items, value, disabled, placeholder, autoComplete, validationError, deleteIndex,
  labelAccessor, onDelete, onSelect, inputOnChange, inputOnClick, onClose, rightAddOn,
}, ref) => {
  const [getTranslation] = useTranslation();

  const getTags = () => (
    tags.map((tag, index) => (
      <BadgeWrapper
        id={tag.id}
        key={tag.id}
        onClick={onDelete}
        label={tag[labelAccessor]}
        hasError={deleteIndex === index}
      />
    ))
  );

  return (
    <ContextMenu
      items={items}
      icon={items?.icon}
      onSelect={onSelect}
      closeOnClick={false}
      closeOnSelfClick={false}
      onClose={onClose}
    >
      <div onClick={inputOnClick} className={clsx('tcm-tags-input', { disabled, error: !!validationError })}>
        {getTags()}
        <Input
          ref={ref}
          value={value}
          onChange={inputOnChange}
          autoComplete={autoComplete}
          placeholder={getTranslation(placeholder)}
          className={clsx('tti-input', { error: !!validationError })}
          rightAddOn={rightAddOn}
        />
      </div>
    </ContextMenu>
  );
});

TagWithSuggestions.defaultProps = {
  tags: [],
  items: [],
  value: '',
  disabled: false,
  placeholder: '',
  deleteIndex: null,
  onDelete: () => {},
  onSelect: () => {},
  validationError: '',
  inputOnClick: () => {},
  inputOnChange: () => {},
  autoComplete: 'new-password',
  labelAccessor: DEFAULT_LABEL_ACCESSOR,
  onClose: () => {},
  rightAddOn: null,
};

TagWithSuggestions.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  onDelete: PropTypes.func,
  onSelect: PropTypes.func,
  inputOnClick: PropTypes.func,
  inputOnChange: PropTypes.func,
  deleteIndex: PropTypes.number,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  labelAccessor: PropTypes.string,
  validationError: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.shape({})),
  items: PropTypes.arrayOf(PropTypes.shape({})),
  onClose: PropTypes.func,
  rightAddOn: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default memo(TagWithSuggestions);
